import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosApiInstance from '../../utils/apiClient';
import { messageFrontEnd } from '../../utils/mensajeErrorCliente';
import { endpoints } from '../config';

const initialState = {
  isLoading: false,
  encuestas: [],
  isSuccess: 'idle',
  message: '',
  voto: {},
  haVotado: false,
  resultados: {},
};

// * LIMPIAR SUCCESS
export const fetchCambiarSuccess = createAsyncThunk('cafeteria/fetchCambiarSuccess', async () => {
  return null;
});

export const fetchBuscarEncuestas = createAsyncThunk(
  'encuesta/fetchBuscarEncuestas',

  async () => {
    const resultado = await axiosApiInstance.get(endpoints.encuestas.getEncuestas);
    return resultado.data;
  }
);

export const fetchEfectuarVoto = createAsyncThunk(
  'encuesta/fetchEfectuarVoto',

  async (voto) => {
    try {
      const resultado = await axiosApiInstance.post(endpoints.encuestas.enviarVoto, voto);
      return resultado.data;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
);

export const fetchEfectuarVotoCriterios = createAsyncThunk(
  'encuesta/fetchEfectuarVotoCriterios',

  async (criteriosEmpleado) => {
    try {
      const resultado = await axiosApiInstance.post(endpoints.encuestas.enviarVotoCriterios, criteriosEmpleado);
      return resultado.data;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
);

export const fetchGenerarGanadoresCriterios = createAsyncThunk(
  'encuesta/fetchGenerarGanadoresCriterios',

  async () => {
    try {
      const resultado = await axiosApiInstance.post(endpoints.encuestas.generarGanadoresCriterios);
      return resultado.data;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
);

export const fetchVerificarVoto = createAsyncThunk('encuesta/fetchVerificarVoto', async (voto) => {
  try {
    const resultado = await axiosApiInstance.post(endpoints.encuestas.validarVoto, voto);
    return resultado.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
});

export const fetchVerResultadosEncuesta = createAsyncThunk(
  'encuesta/fetchVerResultadosEncuesta',

  async (encuestaId) => {
    try {
      const resultado = await axiosApiInstance.get(endpoints.encuestas.verResultado + `?encuestaId=${encuestaId}`);
      return resultado.data;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
);

export const fetchCambiarEstadoEncuesta = createAsyncThunk(
  'encuesta/fetchCambiarEstadoEncuesta',

  async (encuestaId) => {
    try {
      const resultado = await axiosApiInstance.post(endpoints.encuestas.cambiarEstado + `?encuestaId=${encuestaId}`);
      return resultado.data;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
);

export const EncuestasSlice = createSlice({
  name: 'encuestas',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCambiarSuccess.fulfilled, (state) => {
        state.isSuccess = 'idle';
        state.message = '';
      })
      .addCase(fetchBuscarEncuestas.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.encuestas = action.payload.data ?? [];
        } else {
          state.isSuccess = 'error';
          state.message = action.payload.message;
        }
        state.isLoading = false;
      })
      .addCase(fetchBuscarEncuestas.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchBuscarEncuestas.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.encuestas = [];
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })
      .addCase(fetchEfectuarVoto.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.voto = action.payload.data ?? {};
        } else {
          state.isSuccess = 'error';
          state.message = action.payload.message;
        }
        state.isLoading = false;
      })
      .addCase(fetchEfectuarVoto.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchEfectuarVoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.voto = {};
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })
      .addCase(fetchEfectuarVotoCriterios.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
        } else {
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
        state.isLoading = false;
      })
      .addCase(fetchEfectuarVotoCriterios.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchEfectuarVotoCriterios.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.voto = {};
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })
      .addCase(fetchGenerarGanadoresCriterios.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
        } else {
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
        state.isLoading = false;
      })
      .addCase(fetchGenerarGanadoresCriterios.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchGenerarGanadoresCriterios.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.voto = {};
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })
      .addCase(fetchVerificarVoto.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.voto = action.payload.data ?? null;
          state.voto !== null ? (state.haVotado = true) : (state.haVotado = false);
          state.isLoading = false;
        } else {
          state.isSuccess = 'error';
          state.message = action.payload.message;
        }
      })
      .addCase(fetchVerificarVoto.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchVerificarVoto.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.voto = {};
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })

      // ? fetchVerResultadosEncuesta
      .addCase(fetchVerResultadosEncuesta.fulfilled, (state, action) => {
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.isLoading = false;
          state.resultados = action.payload.data ?? null;
        } else {
          state.isSuccess = 'error';
          state.message = action.payload.message;
        }
      })
      .addCase(fetchVerResultadosEncuesta.pending, (state) => {
        state.isSuccess = 'idle';
        state.isLoading = true;
      })
      .addCase(fetchVerResultadosEncuesta.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        console.error(action.error.message);
      });
  },
});

export const selectIsLoading = (state) => state.encuestas.isLoading;
export const selectIsSuccess = (state) => state.encuestas.isSuccess;
export const selectMessage = (state) => state.encuestas.message;
export const selectEncuestas = (state) => state.encuestas.encuestas;
export const selectVoto = (state) => state.encuestas.voto;
export const selectHaVotado = (state) => state.encuestas.haVotado;
export const selectResultados = (state) => state.encuestas.resultados;

export const {} = EncuestasSlice.actions;
export default EncuestasSlice.reducer;
